import React from 'react';

interface InstallButtonProps {
  isAgencyOwner: boolean;
  installed: boolean;
  isAgencyInstalled: boolean;
  installing: boolean;
  /** Set when this person can't install it for themselves yet; shown as the reason. */
  personalBlockedReason?: string;
  onInstall: () => void;
  size?: 'sm' | 'md';
  /** Store page only: a line under the button saying who has it already. */
  showStatus?: boolean;
}

/**
 * One Install button for every listing. Who gets it (just me, or everyone in the
 * agency) is chosen in the install prompt, where the consequences can be spelled
 * out - not in a menu on the button. The button's only job is "install", and the
 * status line says what's already installed.
 */
const InstallButton: React.FC<InstallButtonProps> = ({ isAgencyOwner, installed, isAgencyInstalled, installing, personalBlockedReason, onInstall, size = 'md', showStatus = false }) => {
  // Admins can still install for the agency after installing for themselves (and the
  // other way round); everyone else is done once it's theirs.
  const nothingLeft = isAgencyOwner ? installed && isAgencyInstalled : installed || !!personalBlockedReason;
  const status = isAgencyOwner
    ? installed && isAgencyInstalled ? 'Installed for you and your agency'
      : installed ? 'Installed for you · not yet for your agency'
        : isAgencyInstalled ? 'Installed for your agency'
          : null
    : installed ? 'Installed for you' : personalBlockedReason ?? null;

  return (
    <div className="ms-install">
      <button type="button" className={`mt-btn mt-btn--primary${size === 'sm' ? ' mt-btn--sm' : ' ms-install__btn'}`} disabled={installing || nothingLeft}
        title={!isAgencyOwner ? personalBlockedReason : undefined}
        onClick={e => { e.stopPropagation(); onInstall(); }}>
        {installing ? 'Installing…' : nothingLeft && installed ? 'Installed' : 'Install'}
      </button>
      {showStatus && status && <span className="ms-install__status">{status}</span>}
    </div>
  );
};

export default InstallButton;
